import * as React from 'react'

import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import { IReferral } from '@sales-center/common'
import { Theme } from '@mui/material/styles'

type Props = {
  employeeListStatus: 'pending' | 'success' | 'fail'
  referral: IReferral
}

export function TidalEmployeePreview(props: Props) {
  const { referral } = props

  return (
    <Paper
      variant="outlined"
      sx={{
        backgroundColor: (theme: Theme) => theme.palette.background.default,
        border: 'solid 1px #e0e0e0',
        padding: (theme: Theme) => theme.spacing(1.5),
      }}
    >
      <Stack mb={2}>
        <Typography variant="subtitle2">Referral Type</Typography>
        <Typography variant="body2">Employee</Typography>
      </Stack>
      <Stack>
        <Typography variant="subtitle2">Employee Name</Typography>
        <Typography variant="body2">{referral.referralValue}</Typography>
      </Stack>
    </Paper>
  )
}
